<template>
  <svg
    width="35"
    height="32"
    viewBox="0 0 31 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="insights">
      <path
        id="Vector"
        d="M19.7394 4.62289C20.4648 7.2787 18.2692 10.2236 18.2692 10.2236C18.2692 10.2236 14.9022 8.86816 14.1822 6.21284C13.4622 3.55752 15.6524 0.612094 15.6524 0.612094C15.6524 0.612094 19.0194 1.96756 19.7394 4.62289Z"
        fill="var(--icon-secondary, #43386040)"
      />
      <path
        id="Vector_2"
        d="M15.3649 11.6719C20.2671 16.6134 18.7147 26.1847 18.7147 26.1847C18.7147 26.1847 9.21931 27.7496 4.31704 22.8081C-0.585241 17.8731 0.967254 8.29531 0.967254 8.29531C0.967254 8.29531 10.4626 6.73039 15.3649 11.6719Z"
        fill="var(--icon-secondary, #43386040)"
      />
      <path
        id="Vector_3"
        d="M26.2581 4.66333L22.0122 14.9171H28.5765L24.6455 25.8585"
        stroke="var(--icon-primary, var(--grey800))"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        id="Vector 29"
        d="M18.9481 25.88C18.3053 23.9 13.591 17.24 9.30525 14.54"
        stroke="var(--icon-primary, var(--grey800))"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </svg>
</template>
